<ng-container>
  <nz-select [nzAllowClear]="true" [ngModel]="value" [ngModelOptions]="{ standalone: true }" (ngModelChange)="writeValue($event)"
    [nzDisabled]="disabled" [disabled]="disabled" (blur)="onFieldBlur($event)" nzAllowClear nzShowSearch>
    <nz-option *ngIf="enableCreateOption" nzValue="-100" [nzLabel]="'<Create New Option>' | locale">
    </nz-option>
    <ng-container *ngIf="dropDownsMetaData != null && dropDownsMetaData[field.Code] != null">
      <nz-option *ngFor="let option of dropDownsMetaData[field.Code]" [nzValue]="option.Code" [nzLabel]="option.Label">
      </nz-option>
    </ng-container>
  </nz-select>
</ng-container>

<nz-drawer *ngIf="addOptionDrawer" [nzVisible]="addOptionDrawer" nzWrapClassName="drawer-size-3x" nzClosable="false">
  <ng-container *nzDrawerContent>
    <form nz-form #optionForm="ngForm" (ngSubmit)="postOption(optionForm)">
      <nz-form-item>
        <nz-form-label nzRequired="true" nzFor="name">{{
          'Name' | translate  | locale
          }}</nz-form-label>
        <nz-form-control>
          <input nz-input ngModel type="text" nzRequired="true" required name="name" />
        </nz-form-control>
      </nz-form-item>
      <ng-container *ngFor="let lang of languages">
        <nz-form-item *ngIf="lang.Code !== 0">
          <nz-form-label nzFor="{{ lang.Code }}">{{
            lang.Label
            }}</nz-form-label>
          <nz-form-control>
            <input nz-input ngModel type="text" name="{{ lang.Code }}" />
          </nz-form-control>
        </nz-form-item>
      </ng-container>
      <div>
        <nz-space>
          <button *nzSpaceItem nz-button nzType="primary" type="submit">
            {{'Submit' | translate}}
          </button>
          <button *nzSpaceItem nz-button type="button" (click)="addOptionDrawer = false">
            {{'Cancel' | translate}}
          </button>
        </nz-space>
      </div>
    </form>
  </ng-container>
</nz-drawer>   











<!-- 
 <nz-drawer *ngIf="addOptionDrawer" [nzVisible]="addOptionDrawer" nzWrapClassName="drawer-size-3x" nzClosable="false">
  <ng-container *nzDrawerContent>
    <form nz-form #optionForm="ngForm" (ngSubmit)="postOption(optionForm)">
      <nz-form-item>
        <nz-form-label nzRequired="true" nzFor="name">{{
          "Name" | locale
        }}</nz-form-label>
        <nz-form-control>
          <input nz-input ngModel type="text" nzRequired="true" required name="name" />
        </nz-form-control>
      </nz-form-item>
      <ng-container *ngFor="let lang of languages">
        <nz-form-item *ngIf="lang.Code !== 0">
          <nz-form-label nzFor="{{ lang.Code }}">{{
            lang.Label
          }}</nz-form-label>
          <nz-form-control>
            <input nz-input ngModel type="text" name="{{ lang.Code }}" />
          </nz-form-control>
        </nz-form-item>
      </ng-container>
>
      <div>
        <button nz-button nzType="dashed" (click)="addRow()">Add New Translet</button>
      </div>


      <nz-table #basicTable [nzBordered]="true" [nzData]="rows"
       [nzBordered]="true" [nzSize]="'middle'" [nzShowPagination]="false">
        <thead>
          <tr>
            <th nzWidth="25%">Name</th>
            <th nzWidth="25%">French (Canada)</th>
            <th nzWidth="25%">English (Canada)</th>
            <th nzWidth="25%">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; let i = index">
            <td>
              <input nz-input [(ngModel)]="row.field1" name="name" />
            </td>
            <td>
              <input nz-input [(ngModel)]="row.field2" name="name" />
            </td>
            <td>
              <input nz-input [(ngModel)]="row.field3" name="name" />
            </td>
            <td>
              <button nz-button nzType="default" nzDanger (click)="removeRow(i)">Remove</button>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <div style="margin-top: 16px;">
        <nz-space>
          <button *nzSpaceItem nz-button nzType="primary" type="submit">
            Submit
          </button>
          <button *nzSpaceItem nz-button type="button" (click)="addOptionDrawer = false">
            Cancel
          </button>
        </nz-space>
      </div>
    </form>
  </ng-container>
</nz-drawer>  

 -->
